<template>
  <v-row align="center" justify="center">
    <v-dialog v-model="dialogPolicy" width="600px">
      <registerPolice @close="dialogPolicy = false" />
    </v-dialog>
    <v-dialog v-model="dialogAccess" width="600px">
      <registerAccess @close="dialogAccess = false" />
    </v-dialog>
    <v-col cols="12" sm="12" md="10">
      <v-form ref="form" v-model="valid" :lazy-validation="false">
        <v-card class="elevation-12">
          <v-toolbar class="primary white--text">
            <v-toolbar-title>Регистрация агента </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pb-0">
            <v-radio-group v-model="usersInfo.regType" row class="mt-0">
              <v-radio @change="onChangeRegType" v-for="el in regTypes" :key="el.id" :label="el.label"
                :value="el.id"></v-radio>
            </v-radio-group>
            <!-- <registerOrganisation :regType="usersInfo.regType" :organisation="organisation"/> -->

            <template v-if="usersInfo.regType == 1">
              <v-row>
                <v-col cols="12">
                  <v-text-field dense v-model="usersInfo.inn" :rules="rules.innRulesJL" counter="10"
                    v-mask="rules.inn10mask" label="*ИНН" type="text" required key="1"
                    @change="getAddressAndOrgNameByINN($event)" ref="inn"></v-text-field>
                </v-col>
              </v-row>
            </template>

            <template v-else-if="usersInfo.regType == 2">
              <v-row>
                <v-col cols="12">
                  <v-text-field dense v-if="usersInfo.regType == 2" v-model="usersInfo.inn" :rules="rules.innRulesIP"
                    counter="12" label="*ИНН" type="text" v-mask="rules.inn12mask" key="2"
                    @change="getAddressAndOrgNameByINN($event)" required ref="inn"></v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-else-if="usersInfo.regType == 3">
              <v-row>
                <v-col cols="12">
                  <v-text-field dense v-if="usersInfo.regType == 3" v-model="usersInfo.inn" :rules="rules.innRulesIP"
                    counter="12" label="*ИНН" type="text" key="3" @change="checkInnFromIFNS($event)" required
                    ref="inn"></v-text-field>
                </v-col>
              </v-row>
            </template>
            <div>
              <Loader v-if="loadingINN" class="accents" />
              <template v-else>
                {{ usersInfo.orgName }}
                <br />
                {{ usersInfo.address }}
              </template>
            </div>

            <v-subheader class="subheader m-0 mt-3">Укажите ваши данные</v-subheader>

            <v-row>
              <v-col cols="4" class="pt-1 pb-1">
                <v-text-field :rules="rules.nameRules" masked="false" dense v-model="usersInfo.famil" key="1"
                  label="*Фамилия" required></v-text-field>
              </v-col>
              <v-col cols="4" class="pt-1 pb-1">
                <v-text-field :rules="rules.nameRules" dense v-model="usersInfo.name" label="*Имя"
                  required></v-text-field>
              </v-col>
              <v-col cols="4" class="pt-1 pb-1">
                <v-text-field dense v-model="usersInfo.otch" label="Отчество"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-1 pb-1">
                <v-text-field dense v-model="usersInfo.phone" placeholder="(xxx)xxx xx xx" prepend-icon="phone"
                  v-mask="rules.phonemask" prefix="+7" :rules="rules.phoneRules" required
                  @paste="onPasteFromClipboardNumber($event)"></v-text-field>
              </v-col>
              <v-col cols="6" class="pt-1 pb-1">
                <v-text-field dense v-model="usersInfo.email" prepend-icon="email" :rules="rules.emailRules"
                  placeholder="Email адрес" type="email" required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col style="display: inline-block;font-size: 16px;">
                <v-checkbox :rules="rules.emptyRules" required style="display: inline-block; margin-top: 0;">
                  <template slot="label">
                    <span class="mr-2">
                      Я ознакомлен и согласен с условиями
                    </span>
                  </template>
                </v-checkbox>
                <a href="https://vmmm.ru/agreement" target="_blank"
                  style="display: inline-block; height: 40px;position: relative; top: -7px; margin-left: 5px;">Пользовательского
                  соглашения,</a>
                <a href="https://vmmm.ru/personal-privancy" target="_blank"
                  style="display: inline-block; height: 40px;position: relative; top: -7px; margin-left: 5px;">Политикой
                  обработки персональных данных,</a>
                <a href="https://vmmm.ru/privacy" target="_blank"
                  style="display: inline-block; height: 40px;position: relative; top: -7px; margin-left: 5px;">Политикой
                  использования файлов cookie.</a>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="text-center" cols="12">
                <v-btn :disabled="!valid" type="submit" color="primary"
                  @click.prevent="Register()">Зарегистрироваться</v-btn>
              </v-col>
            </v-row>
            <!-- <v-row>
              {{usersInfo}}
            </v-row>
            <v-row>
              {{organisation}}
            </v-row> -->
            <v-row>
              <v-col class="text-center" cols="12">
                <a @click.prevent="ToLogin">Уже зарегистрированы? Войти</a>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import Globalrules from "../components/api/rules.js";
import registerPolice from "./registerPolitic.vue";
import registerAccess from "./registerAccess.vue";
import Loader from "../components/loading.vue";
// import registerOrganisation from './orginfo/registerOrganisation'
import Swal from "sweetalert2";
export default {
  name: "registerAgent",
  components: {
    registerPolice,
    registerAccess,
    Loader,
    // registerOrganisation,
  },
  data: () => ({
    loadingINN: false,
    dialogPolicy: false,
    dialogAccess: false,
    rules: Globalrules,
    valid: true,
    checkbox: false,
    organisation: {
      JurIPSam: "",
      orgName: "",
      orgShortName: "",
      pravForm: 1,
      nologObl: 0,
      inn: "",
      ogrn: "",
      kpp: "",

      okato: "",
      oktmo: "",

      directorDolgn: "",
      directorFamil: "",
      directorName: "",
      directorOtch: "",
      directorPhone: "",
      directorEmail: "",
      directorPassportSer: "",
      directorPassportNumber: "",
      directorPassportVidan: "",
      directorPassportDataVidachi: "",
      directorPassportKodPord: "",

      jurrAddr: "",
      factAddr: "",

      jurAddrSovpSFactich: true,
      addrForCorrespondence: "3",

      address: "",
    },
    usersInfo: {
      clientAgent: "agent",
      regType: 1,
      inn: "",
      famil: "",
      name: "",
      otch: "",
      phone: "",
      email: "",
      orgName: "",
      address: "",
    },
    selfEmployed: null,
    regTypes: [
      { id: 1, label: "Юридическое Лицо" },
      { id: 2, label: "Индивидуальный Предприниматель" },
      { id: 3, label: "Самозанятый" },
    ],
  }),

  computed: {
    error() {
      return this.$store.getters.getError;
    },
    // enabledLog() {
    //   return this.$store.getters.getProcessing;
    // },
  },
  methods: {
    onPasteFromClipboardNumber(event) {
      let phone = event.clipboardData.getData("text");
      phone = phone.trim().replace(/(\r\n|\n|\r)/g, "");

      if (phone !== "" && phone.length >= 2) {
        if (phone.charAt(0) == "+" && phone.charAt(1) == "7") {
          this.usersInfo.phone = phone.substr(2);
          event.preventDefault();
        } else if (phone.charAt(0) === "8") {
          this.usersInfo.phone = phone.substr(1);
          event.preventDefault();
        } else if (phone.charAt(0) == "+") {
          event.preventDefault();
        }
      }
    },
    async checkInnFromIFNS(inn) {
      this.usersInfo.orgName = "";

      const showErrMess = (errmessage) => {
        Swal.fire({
          icon: "error",
          title: errmessage,
        });
      };
      const showMess = () => {
        Swal.fire({
          icon: "warning",
          title: "Статус самозанятого НЕ подтвержден",
        });
      };
      const NotCorrectINN = () => {
        Swal.fire({
          icon: "warning",
          title: "ИНН не корректный",
        });
      };

      const setOrgName = (data) => {
        this.selfEmployed = data;
        this.usersInfo.orgName = "Статус самозанятого подтвержден";
      };

      if (inn.length === 12) {
        const { data } = await this.$store.dispatch("checkInnFromIFNS", inn);
        !data.errmessage ? setOrgName(data) : showErrMess(data.errmessage);
      } else {
        NotCorrectINN();
      }
    },
    getAddressAndOrgNameByINN(inn) {
      if (inn === "") {
        return;
      }
      this.loadingINN = true;
      const IP = () => {
        this.organisation.pravForm = "3";
      };
      const Sam = () => {
        this.organisation.pravForm = "3";
        this.organisation.nologObl = "НПД";
      };
      const clearPhone = (phone) => {
        const reg = /\+7\s|\+\s7\s|8\s|8|\s8\s|\s8/;
        const reg1 = /\(|\)/g;
        const numPhone = phone
          .replace(reg, "")
          .replace(reg1, "")
          .replace(/\s/, "")
          .replace(/-/g, "");
        // (xxx)xxx xx xx
        return `(${numPhone.slice(0, 3)})${numPhone.slice(
          3,
          6
        )} ${numPhone.slice(6, 8)} ${numPhone.slice(8, 10)}`;
      };

      this.$store.dispatch("FillByINN", { inn }).then((res) => {

        if (res.status_api === "gosebase") {
          const data = res.data.main.data;
          this.organisation.inn = data.inn;
          this.organisation.orgName =
            data.name && data.name.full_with_opf ? data.name.full_with_opf : "";
          this.organisation.orgShortName =
            data.name && data.name.short_with_opf
              ? data.name.short_with_opf
              : "";
          this.organisation.kpp = data.kpp;
          this.organisation.ogrn = data.ogrn;
          this.organisation.jurrAddr =
            data.address && data.address.unrestricted_value
              ? data.address.unrestricted_value
              : "";
          this.organisation.okato = data.okato;
          this.organisation.oktmo = data.oktmo;
          this.organisation.address =
            data.address && data.address.unrestricted_value
              ? data.address.unrestricted_value
              : "";
          if (data.management && data.management.name) {
            let FIO = data.management.name.split(" ");
            this.organisation.directorFamil = FIO[0];
            this.organisation.directorName = FIO[1];
            this.organisation.directorOtch = FIO[2];
            this.organisation.directorDolgn =
              data.management && data.management.post
                ? data.management.post
                : "";
            this.usersInfo.famil = FIO[0];
            this.usersInfo.name = FIO[1];
            this.usersInfo.otch = FIO[2];
          }
          this.usersInfo.email =
            res.mails && res.mails[0] && res.mails[0].email
              ? res.mails[0].email
              : "";
          this.usersInfo.phone =
            res.phones && res.phones[0] && res.phones[0].phone
              ? clearPhone(res.phones[0].phone)
              : "";
          this.usersInfo.orgName =
            data.name && data.name.short_with_opf
              ? data.name.short_with_opf
              : "";
          this.usersInfo.address =
            data.address && data.address.unrestricted_value
              ? data.address.unrestricted_value
              : "";
        } else if (res.status_api === "dadata") {
          // address: "443013, ОБЛАСТЬ САМАРСКАЯ, ГОРОД САМАРА, ПРОСПЕКТ КАРЛА МАРКСА, ДОМ 55, ОФИС 1,2,3"
          // directorDolgn: ""
          // directorName: ""
          // inn: 6316170000
          // kpp: "631101001"
          // longName: "ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "ПРОМСТРОЙКОНТАКТ-ПОВОЛЖЬЕ""
          // name: "ООО "ПСК-ПОВОЛЖЬЕ""
          // ogrn: 1116316009633
          // okato: 36401364000
          // oktmo: 36701305000
          // region: "Самарская"
          // timezone: "+4"
          const data = res.data[0];
          this.organisation.inn = data.inn;
          this.organisation.orgName = data.longName;
          this.organisation.orgShortName = data.name;
          this.organisation.kpp = data.kpp;
          this.organisation.ogrn = data.ogrn;
          this.organisation.jurrAddr = data.address;
          this.organisation.okato = data.okato;
          this.organisation.oktmo = data.oktmo;
          this.organisation.address = data.address;
          if (data.directorName) {
            let FIO = data.directorName.split(" ");
            this.organisation.directorFamil = FIO[0];
            this.organisation.directorName = FIO[1];
            this.organisation.directorOtch = FIO[2];
            this.organisation.directorDolgn = data.directorDolgn;
            this.usersInfo.famil = FIO[0];
            this.usersInfo.name = FIO[1];
            this.usersInfo.otch = FIO[2];
          }
          this.usersInfo.email = "";
          this.usersInfo.phone = "";
          this.usersInfo.orgName = data.longName;
          this.usersInfo.address = data.address;
        } else {
          if (res.error == "No data.") {
            Swal.fire({
              icon: "warning",
              title: "ИНН в базе данных отсутствует.",
              text: "Проверьте, правильно ли вы его указали",
            });
            return;
          }
        }

        this.regType == 2 && IP();
        this.regType == 3 && Sam();
        this.loadingINN = false;
      });
    },
    clearOrgInfo() {
      this.usersInfo.orgName = "";
      this.usersInfo.address = "";
    },
    ShowPrivatePolicy() {
      this.dialogPolicy = true;
    },
    ToLogin() {
      this.$router.push("/login");
    },

    Register() {
      //TODO Переделать регистрацию
      if (this.usersInfo.orgName == "") {
        Swal.fire({
          icon: "error",
          title: "Неизвестная организация",
          text: "Введите правильный ИНН и нажмите кнопку заполнить.",
        });
        return;
      }
      if (this.$refs.form.validate()) {
        if (this.usersInfo.regType === 3) {
          this.usersInfo.orgName = `Самозанятый ${this.usersInfo.famil.trim()} ${this.usersInfo.name.trim()} ${this.usersInfo.otch.trim()}`;
        }
        this.$store
          .dispatch("SIGNUP", {
            userInfo: this.usersInfo,
            company: this.organisation,
          })
          .then(() => {
            if (this.$store.getters.getErrorApi == "EMAILNOTUNIQUE") {
              Swal.fire({
                icon: "error",
                title: "Email не уникальный",
                text: `Пользователь с email ${this.usersInfo.email} уже зарегистрирован в системе.`,
              });
            } else if (this.$store.getters.getErrorApi == "COMPANYNOTUNIQUE") {
              Swal.fire({
                icon: "error",
                title: "Компания с таким ИНН уже зарегистрирована",
                text: "Для добавления нового пользователя можете обратиться к администратору \
                       Вашей компании или в техподдержку Cервиса по тел. 8 800 25 05 805, по почте help@vmmm.ru",
              });
            } else if (this.$store.getters.getErrorApi == "SZNOTUNIQUE") {
              Swal.fire({
                icon: "error",
                title: "Самозанятый с таким ИНН уже зарегистрирован",
                text: "Восстановите пароль и войдите в вашу учетную запись!",
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Ваш запрос на регистрацию отправлен",
                text: "Письмо с логином и паролем отправлено на указанную Вами электронную почту",
              });
              this.$router.push("/login");
            }
          });
      }
    },
    onChangeRegType() {
      this.organisation = {
        JurIPSam: "",
        orgName: "",
        orgShortName: "",
        pravForm: 1,
        nologObl: 0,
        inn: "",
        ogrn: "",
        kpp: "",

        okato: "",
        oktmo: "",

        directorDolgn: "",
        directorFamil: "",
        directorName: "",
        directorOtch: "",
        directorPhone: "",
        directorEmail: "",
        directorPassportSer: "",
        directorPassportNumber: "",
        directorPassportVidan: "",
        directorPassportDataVidachi: "",
        directorPassportKodPord: "",

        jurrAddr: "",
        factAddr: "",

        jurAddrSovpSFactich: true,
        addrForCorrespondence: "3",

        address: "",
      };
      this.usersInfo.inn = "";
      this.usersInfo.orgName = "";
      this.usersInfo.address = "";
    },
  },
  mounted() {
    this.setTitle("Регистрация агента");
  },
};
</script>

<style lang="scss">
#app {
  .subheader {
    color: #82b1ff;
    font-size: 18px;
    height: 20px;
  }

  .centeredBlock {
    margin: auto;
    float: none;
  }
}
</style>
